(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-text.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-text.js');
'use strict';

const IconText = svs.tb_ui_react.icon_text.IconText;

const MobileText = () => {
  const _ref = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences) || {},
    cellPhoneStatus = _ref.cellPhoneStatus,
    cellphone = _ref.cellphone;
  const mobileVerified = "".concat(cellPhoneStatus) === '2';
  const mobileExists = Boolean(cellphone);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    id: "currentMobileNumber"
  }, cellphone || ''), !mobileVerified && React.createElement(IconText, {
    className: cellphone ? 'padding-top-1' : ''
  }, mobileExists && React.createElement("span", null, "Ditt mobilnummer \xE4r obekr\xE4ftat"), !mobileExists && React.createElement("span", null, "Du har inget mobilnummer angivet")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileText = MobileText;

 })(window);